<ng-container *ngIf="operation$ | async as operation">
  <ng-container *ngIf="addresses && user">
    <x-page-panel
      [heading]="heading"
      headingAlignment="left"
      [panelLoading]="operation.status === 'loading'"
    >
      <ng-container *ngIf="hasNotification">
        <ng-content select="[xRequirementNotification]"></ng-content>
      </ng-container>
      <x-banner-button-group *ngIf="addresses.length; else NOADDRESSES_FALLBACK">
        <x-banner-button
          class="address-button"
          *ngFor="let address of addresses; trackBy: 'id' | trackBy"
          [radioButton]="radioButtons"
          (click)="selectAddress(address)"
          [active]="address.id === selectedAddressId || address.hash === selectedAddressHash"
          iconPrefixAlignment="top"
        >
          <div class="address-detail d-flex">
            <div class="detail flex-grow-1">
              <div class="name mat-body-2 mb-2 d-flex align-items-center gap-2">
                <b class="fw-normal">{{ address.firstName }}</b>
                <span *ngIf="address.isDefaultShippingAddress" class="mat-body-2">(default)</span>
                <mat-basic-chip class="alias" *ngIf="address.alias" [disableRipple]="true">
                  {{ address.alias }}
                </mat-basic-chip>
              </div>
              <div class="address-info mat-display-2">
                <div class="street">{{ address.street }}</div>
                <div class="suburb">{{ address.suburb }}</div>
                <div class="city">{{ address.city }} {{ address.postalCode }}</div>
                <div class="country">{{ address.country }}</div>
              </div>
            </div>
          </div>

          <div *ngIf="address.instructions" xIntruction>
            {{ address.instructions }}
          </div>

          <button
            *ngIf="addressActions.includes('edit')"
            xAction
            mat-button
            color="primary"
            (click)="updateAddress(address, user, $event)"
            i18n="@@CallToAction.Edit"
          >
            Edit
          </button>

          <button
            *ngIf="addressActions.includes('delete')"
            xAction
            mat-button
            color="primary"
            (click)="deleteAddress(address, $event)"
            (mouseover)="hideTooltip()"
            (mouseout)="showTooltip()"
            i18n="@@CallToAction.Delete"
          >
            Delete
          </button>
        </x-banner-button>
      </x-banner-button-group>

      <button
        class="add-address"
        color="accent"
        mat-flat-button
        xActionFooter
        *ngIf="addressActions.includes('create')"
        [disabled]="disableAddressActions"
        (click)="createAddress(user)"
        i18n="@@CallToAction.AddAddress"
      >
        Add address
      </button>
    </x-page-panel>
  </ng-container>
</ng-container>

<ng-template #NOADDRESSES_FALLBACK>
  <ng-container *ngIf="!hasNotification">
    <p class="mat-body-1" i18n="@@AddressBook.NoAddresses.Note">
      You currently have no saved addresses.
    </p>
  </ng-container>
</ng-template>
